function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -185.851 776.978 634.292",
    style: {
      shapeRendering: "geometricprecision"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.124435, -332.206085)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M211.63 378.8l151.9 0 71.01 70.52c44.56,-6.25 240.79,-33.85 292.64,-39.68 69.45,-7.8 83.81,52.35 19.75,95.16 0.62,0.64 -256.04,177.12 -329.56,163.98 -63.29,-11.29 -146.21,-66.74 -166.16,-80.56l-39.58 0 0 2.18c0,28.67 -23.61,52.29 -52.27,52.29l-48.35 0c-28.76,0 -52.29,-23.53 -52.29,-52.29l0 -223.09c0,-28.76 23.53,-52.27 52.29,-52.27l48.35 0c28.77,0 52.27,23.51 52.27,52.27l0 11.49zm287.83 25.96c245.36,-85.54 96.6,-299.68 0,-203.03 -102.26,-94.35 -251.71,134.98 0,203.03zm-12.97 -186.38l25.85 0 0 12.65c17.77,3.4 29.2,14.94 29.86,33.57l-23.01 0.82c-2.01,-12.25 -8.49,-16.53 -20.55,-16.53 -6.63,0 -11.86,1.45 -15.51,4.22 -4.9,3.51 -4.76,10.1 -0.25,13.84 7.64,6.48 33.34,9.37 45.59,15.85 11.77,6.25 17.1,16.48 17.1,29.55 0,13.78 -8.07,25.79 -20.8,30.93 -3.55,1.54 -7.79,2.64 -12.43,3.37l0 12.4 -25.85 0 0 -12.79c-20.37,-3.83 -30.7,-17.33 -33.14,-37.62l22.33 -2.2c2.59,14.12 9.99,21.76 24.69,21.76 9.65,0 22.19,-4.02 22.19,-15.71 0,-6.68 -4.79,-9.65 -10.56,-11.72 -13.5,-4.84 -33.2,-6.48 -43.96,-16.24 -11.34,-10.17 -13.87,-26.32 -5.47,-39.15 5.38,-8.35 14.41,-12.73 23.92,-14.4l0 -12.6zm-274.86 332.89l50.98 0c33.37,22.26 124.45,81.14 161.26,81.14 53.34,9.49 247.38,-121.16 302.43,-158.21 16.74,-11.14 43.37,-32.3 4.95,-27.89 -42.97,4.81 -193.46,25.81 -263.78,35.7l17.22 17.08c49.18,48.78 -19.41,137.72 -82.26,74.87l-68.76 -68.87 26.09 -25.99 68.76 68.77c28.18,28.17 44.67,-8.29 30.17,-22.69l-110.24 -109.43 -136.82 0 0 135.52zm-52.27 -199.28l-48.35 0c-8.53,0 -15.33,6.79 -15.33,15.32l0 223.09c0,8.44 6.89,15.33 15.33,15.33l48.35 0c8.48,0 15.32,-6.84 15.32,-15.33l0 -223.09c0,-8.44 -6.87,-15.32 -15.32,-15.32z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, sans-serif",
      fontSize: 5,
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: -18.124,
    y: 529.454
  }, "Created by emkamal kamaluddin"), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, sans-serif",
      fontSize: 5,
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: -18.124,
    y: 534.454
  }, "from the Noun Project"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationBlack);
export default __webpack_public_path__ + "static/media/DonationBlack.667c1e30c365bbea6b9b7877b435a6aa.svg";
export { ForwardRef as ReactComponent };